import { render, staticRenderFns } from "./RDescrizioneDialog.vue?vue&type=template&id=2697004c&scoped=true&"
import script from "./RDescrizioneDialog.vue?vue&type=script&lang=js&"
export * from "./RDescrizioneDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2697004c",
  null
  
)

export default component.exports